import sortFacesByAxis from '../../polyMesh/geometric/operator/sortFacesByAxis';

const SortFacesByAxis = {
  schema: {
    axis: { label: 'Direction', type: 'Vec3', step: 0.1, defaultValue: { x: 1, y: 1, z: 0 }, animatable: true },
  },

  update: function (operator, primitive, { store }) {
    //using an import from player.js for getThreeCamera for some reason wipes the active camera
    //const camera =  store.getIn(['player','threeCamera']);
    //const cameraWorldMatrix = camera.matrix;
    const axis = operator.axis.normalize();

    //does not account for the local space of an object
    //const cameraDirection = new THREE.Vector3(0,0,-1);
    //cameraDirection.transformDirection(cameraWorldMatrix);

    const polyMesh = primitive.mesh;
    primitive.mesh = sortFacesByAxis(polyMesh, axis);
  },
};

export default SortFacesByAxis;



// WEBPACK FOOTER //
// ./src/operators/PolyMesh/SortFacesByAxis.js